import React, { Component } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useCart } from '../../lib/cart';
export function Footer({
  forceEmilius = false
}: {
  forceEmilius?: boolean;
}) {
  const {
    slug: urlSlug
  } = useParams<{
    slug: string;
  }>();
  const {
    cart
  } = useCart();
  // Emilius "white-label" mode — sin links al marketplace de NOIZA.
  // Mismo discriminador que MarketplaceHeader: URL o slug del carrito.
  // `forceEmilius` cubre pantallas (ej. order-confirmation) donde la URL
  // no trae slug y el carrito ya fue vaciado tras el checkout.
  const isEmiliusFlow = forceEmilius || urlSlug === 'emilius-pizza' || cart.restaurantSlug === 'emilius-pizza';
  if (isEmiliusFlow) {
    return <footer className="bg-[#0B0B0B] border-t border-white/10 text-white py-6 mt-auto" data-id="element-2066">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center gap-2 text-center" data-id="element-2067">
          <p className="text-white/40 text-xs" data-id="element-2068">
            © {new Date().getFullYear()} Emilius Pizza. Todos los derechos
            reservados.
          </p>
          <p className="text-[10px] tracking-wide text-white/25 select-none" aria-label="Powered by noizacr.com" data-id="element-2069">
            Powered by noizacr.com
          </p>
        </div>
      </footer>;
  }
  return <footer className="bg-[#0B0B0B] border-t border-white/10 text-white py-12 mt-auto" data-id="element-2070">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2071">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-2072">
          <div className="col-span-1 md:col-span-2" data-id="element-2073">
            <div className="flex items-center gap-2 mb-4" data-id="element-2074">
              <div className="w-8 h-8 bg-[#C9A34E] rounded-lg flex items-center justify-center" data-id="element-2075">
                <span className="text-[#0B0B0B] font-bold text-lg leading-none" data-id="element-2076">
                  N
                </span>
              </div>
              <span className="font-bold text-xl tracking-tight text-white" data-id="element-2077">
                NOIZA
              </span>
            </div>
            <p className="text-white/40 max-w-sm mb-6" data-id="element-2078">
              El marketplace gastronómico de Los Santos. Descubre, ordena y
              disfruta de los mejores restaurantes de la zona en un solo lugar.
            </p>
          </div>

          <div data-id="element-2079">
            <h4 className="font-semibold text-white mb-4" data-id="element-2080">Explorar</h4>
            <ul className="space-y-3" data-id="element-2081">
              <li data-id="element-2082">
                <Link to="/" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-2083">
                  Inicio
                </Link>
              </li>
              <li data-id="element-2084">
                <Link to="/restaurants" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-2085">
                  Restaurantes
                </Link>
              </li>
              <li data-id="element-2086">
                <Link to="/cart" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-2087">
                  Carrito
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-2088">
            <h4 className="font-semibold text-white mb-4" data-id="element-2089">Para Restaurantes</h4>
            <ul className="space-y-3" data-id="element-2090">
              <li data-id="element-2091">
                <Link to="/onboarding" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-2092">
                  Únete a NOIZA
                </Link>
              </li>

              <li data-id="element-2093">
                <a href={`https://wa.me/50688118105?text=${encodeURIComponent('Hola, requiero soporte con: _________\n\nNombre del restaurante:\nCorreo electrónico registrado:\nNombre de quien contacta:')}`} target="_blank" rel="noopener noreferrer" className="text-white/40 hover:text-[#C9A34E] transition-colors" data-id="element-2094">
                  Soporte
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-2095">
          <p className="text-white/30 text-sm" data-id="element-2096">
            © {new Date().getFullYear()} NOIZA. Todos los derechos reservados.
            Los Santos, Costa Rica.
          </p>
          <div className="flex gap-4" data-id="element-2097">
            <Link to="/terminos-restaurantes" className="text-white/30 hover:text-[#C9A34E] text-sm transition-colors" data-id="element-2098">
              Términos
            </Link>
            <Link to="/terminos-restaurantes" className="text-white/30 hover:text-[#C9A34E] text-sm transition-colors" data-id="element-2099">
              Privacidad
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}